import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { backendApiUrl, backendBaseUrl } from '../../api/config';
import { makeRequest } from '../../api/api';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';

const initialState = {
  data: [],
  loading: false,
  error: false
};

export const getLearnerAttendance = createAsyncThunk( // no longer in use
  'v1/learner-management/learners/attendance',
  async (param, thunkApi) => {
    try {
      let objectBody = {
        learnerId: '2776',
        programId: '38'
      };
      const response = await makeRequest(
        SERVICES.VASSIST_SERVICE,
        'v1/learner-management/learners/attendance',
        METHODS.POST,
        {},
        objectBody
      );

      if (response.status == 200) {
        console.log('DATA ATTENDANCE', response?.data);
      }
    } catch (error) {
      console.log('ERROR', error);
    }
  }
);

export const learnerDataSliceNew = createSlice({
  name: 'learnerDataSliceNew',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLearnerAttendance.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLearnerAttendance.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(getLearnerAttendance.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
  }
});

export const {} = learnerDataSliceNew.actions;

export default learnerDataSliceNew.reducer;
